export default {"src":"/_next/static/media/sber-logo.fff13661.svg","height":24,"width":89};